export default __webpack_public_path__ + "images/305d9e08a8356836d11471cdaa11196c-minneapolis_mobile.webp";